import * as types from '../mutation-types';
import { share } from '../../api';

const state = {
  shares: [],
  pagination: null,
  detail: {},
  shareComments: [],
  commentsPagination: null,
  commentDetail: {},
};

const getters = {
  // eslint-disable-next-line
  getShareDetail: (s) => (id) => {
    return s.detail;
  },
};

const actions = {
  fetchShares({ commit }, params) {
    return share.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_SHARES, { data: response, params });
    });
  },
  fetchShareDetail({ commit }, id) {
    return share.getId(id).then(({ data: response }) => {
      commit(types.RECEIVE_SHARE_DETAIL, { data: response });
    });
  },
  fetchShareComments({ commit }, params) {
    return share.getComment(params).then(({ data: response }) => {
      commit(types.RECEIVE_SHARE_COMMENT, { data: response });
    });
  },
  submitComment({ commit }, params) {
    return share.postComment(params).then(({ data: response }) => {
      commit(types.RECEIVE_SHARE_COMMENT_DETAIL, { data: response });
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_SHARES](s, { data }) {
    s.shares = [...data.data];
    s.pagination = data.meta.pagination;
  },
  [types.RECEIVE_SHARE_DETAIL](s, { data }) {
    s.detail = data.data;
  },
  [types.RECEIVE_SHARE_COMMENT](s, { data }) {
    s.shareComments = [...data.data];
    s.commentsPagination = data.meta.pagination;
  },
  [types.RECEIVE_SHARE_COMMENT_DETAIL](s, { data }) {
    s.commentDetail = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/share.js